export const goalsEn = {
    GoalEditView: {
        goalTypeHint: {
            Personal: "Track personal development or individual work.",
            Team: "Align a team's shared goals, projects, or cross-functional work.",
            Organization: "Unite everyone around a shared mission."
        },
        visibilityHint: {
            AllOrganization: "Anyone in the organization can find and read this goal.",
            OwnerAndContributorsOnly: "Always visible to executives, and to every manager above the owner and contributors."
        },
        trackingMethodHint: {
            Simple: "Track one percentage from 0% to 100%.",
            Measurements: "Track one or more measurable outcomes — numbers, currency, or yes/no.",
            SubGoals: "Roll progress up from child goals.",
            SubGoalsAutomatic: "Roll progress up from child goals."
        },
        newGoal: "New goal",
        editGoal: "Edit goal",
        loading: "Loading the goal",
        loadingMore: "Loading more results",
        searching: "Searching",
        cancel: "Cancel",
        save: "Save",
        saveDraft: "Save as draft",
        publish: "Publish goal",
        assistant: {
            guideSuggestion: "Guide me through creating this goal.",
            ideasSuggestion: "Suggest some goal ideas.",
            refineSuggestion: "Help me refine this goal."
        },
        autoSave: {
            saving: "Saving in progress. Hang tight!",
            saved: "All changes saved",
            error: "Changes not saved"
        },
        assistantUpdated: "Workleap AI updated this goal",
        discard: {
            heading: "Discard your changes?",
            body: "Edits are not automatically saved. If you leave, any changes you made will be lost.",
            keepEditing: "Keep editing",
            discard: "Discard changes"
        },
        trackingMethodChange: {
            heading: "Change how progress is measured?",
            body: "The metrics on this goal will be deleted once your change is saved. This can't be undone.",
            keepMeasurements: "Keep metrics",
            confirm: "Delete metrics"
        },
        ownerChange: {
            heading: "Hand over this goal?",
            body: "You can edit this goal because you own it. Once someone else owns it, you will no longer be able to make changes.",
            keepEditing: "Keep editing",
            confirm: "Change the owner"
        },
        goalType: {
            Personal: "Personal",
            Team: "Team",
            Organization: "Organization"
        },
        parentGoalType: {
            Personal: "Personal",
            Team: "Team",
            Organization: "Organization"
        },
        visibility: {
            AllOrganization: "Entire organization",
            OwnerAndContributorsOnly: "Owner and contributors only"
        },
        trackingMethod: {
            Simple: "Simple progress",
            Measurements: "Metrics",
            SubGoals: "Sub-goals",
            SubGoalsAutomatic: "Sub-goals"
        },
        validation: {
            emptyField: "This field is empty",
            endBeforeStart: "End date must be on or after the start date"
        },
        toast: {
            published: "Goal published successfully",
            publishError: "Error publishing goal",
            publishInvalid: "This goal can't be published — some of its details are incomplete or invalid.",
            saved: "Goal updated successfully",
            error: "Error updating goal"
        },
        define: {
            heading: "Define your goal",
            title: "Goal name",
            titlePlaceholder: "Enter goal name",
            descriptionLabel: "Description",
            descriptionPlaceholder: "Explain why this matters or how you'll achieve it",
            startDate: "Start date",
            endDate: "End date",
            parent: "Align as a sub-goal of",
            parentPlaceholder: "Search or select a goal to connect as a sub-goal",
            noParentResults: "No results found.",
            parentRestriction: "This is a {{goalType}} goal, so only {{allowedParentTypes}} goals can be its parent."
        },
        involved: {
            heading: "Who is involved",
            owner: "Owner",
            ownerPlaceholder: "Search or select an owner",
            noOwnerResults: "You can only add people from your immediate team (your manager and your direct peers).",
            goalType: "Who will contribute to this goal?",
            contributors: "Which teams or members will contribute to this goal?",
            contributorsPlaceholder: "Search teams or members",
            noContributorResults: "You can only add people from your immediate team (your manager, your direct peers, and the teams you belong to).",
            contributorsHierarchy: "Which people or groups will contribute to this goal?",
            contributorsPlaceholderHierarchy: "Search people, direct reports, or reporting lines",
            noContributorResultsHierarchy: "You can only add people from your immediate team (your manager and your direct peers), and the reports of the managers you can see.",
            members: "Members",
            teams: "Teams",
            directReports: "Direct reports",
            reportingLines: "Reporting lines",
            directReportsOf: "{{name}}'s direct reports",
            reportingLineOf: "{{name}}'s reporting line",
            refineForMoreGroups: "Showing the closest matching managers. Search by name to find others.",
            selectedContributors: "Selected contributors",
            contributorLimit: "You can select up to {{max}} contributors.",
            unknownContributor: {
                Member: "Deleted member",
                Team: "Unknown team",
                Organization: "Entire organization",
                DirectReports: "Deleted member",
                ReportingLine: "Deleted member"
            },
            typeRestrictedTitle: "Limited by the parent goal",
            typeRestrictedDescription: "Only {{allowedGoalTypes}} can be selected while this goal is linked to a {{parentGoalType}} parent.",
            typeRestrictedHint: "Want more people to contribute? Clear or change the parent selected above.",
            typeConflictTitle: "Your current type isn't allowed under this parent",
            typeConflictDescription: "The parent is a {{parentGoalType}} goal — pick {{allowedGoalTypes}} to continue.",
            typeConflictHint: "Want to keep your current type? Clear or change the parent selected above.",
            visibility: "Goal visibility",
            contributorsRequired: "A team goal needs at least one contributor.",
            contributorsHint_one: "{{count}} contributor on this goal.",
            contributorsHint_other: "{{count}} contributors on this goal."
        },
        measure: {
            heading: "How progress is measured",
            methodLabel: "How will you measure this goal?",
            autoUpdate: "Auto-update from sub-goals",
            autoUpdateHint: "Progress rolls up from the sub-goals below.",
            columnMeasurement: "Measurement",
            columnSubgoal: "Sub-goal",
            columnWeight: "Weight",
            titleLabel: "Title",
            unitLabel: "Unit",
            startLabel: "Start at",
            targetLabel: "Target",
            weightLabel: "Weight",
            weightAuto: "auto %",
            linkLabel: "Related link",
            options: "Measurement options",
            optionsFor: "Options for {{title}}",
            addLink: "Add a link",
            addPlaceholder: "Add a measurement",
            add: "Add",
            remove: "Remove measure",
            noSubgoals: "This goal has no sub-goals to weight yet.",
            weightOver: "Combined weights cannot exceed 100% (currently {{total}})",
            weightUnder: "Combined weights must total 100% (currently {{total}})",
            unit: {
                percentage: "Percent",
                numeric: "Numeric",
                currency: "Currency",
                boolean: "Yes / No"
            }
        }
    }
};
